import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Tooltip } from "./Tooltip";
import { useTooltipEvents } from "./useTooltipEvents";
import { useTooltipPosition } from "./useTooltipPosition";

export const RegularTooltip = ({
  placement,
  modifiers,
  showTooltip,
  className,
  content,
  disableEvents,
  children,
  tooltipRootClassName,
  ...attrs
}) => {
  const [isTooltipVisible, toggleStateEvents] = useTooltipEvents();
  const {
    setReferenceElement,
    setPopperElement,
    setArrowElement,
    styles,
    attributes,
  } = useTooltipPosition(placement, modifiers);

  const events = disableEvents ? {} : toggleStateEvents;

  return (
    <div
      className={classNames("tooltip-referrer", tooltipRootClassName)}
      {...events}
      {...attrs}
      ref={setReferenceElement}
    >
      {children}

      {(isTooltipVisible || showTooltip) && (
        <Tooltip
          className={className}
          setPopperElement={setPopperElement}
          setArrowElement={setArrowElement}
          styles={styles}
          attributes={attributes}
        >
          {content}
        </Tooltip>
      )}
    </div>
  );
};

RegularTooltip.propTypes = {
  placement: PropTypes.string,
  modifiers: PropTypes.array,
  showTooltip: PropTypes.bool,
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  disableEvents: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
